import React from "react";
import { Route } from "react-router-dom";

import "./DocumentAbstract.scss";
import NavigationItems from "../../NavigationItems/NavigationItems";
import RenderedAbstract from "./RenderedAbstract/RenderedAbstract";

class DocumentAbstract extends React.Component {
  render() {
    return (
      <div className="document-abstract">
        <div className="document-abstract-header">
          <NavigationItems
            parsedAbstract={this.props.parsedAbstract}
            // navItems={this.state.navItems}
            navItems={[]}
            place="abstract"
            navUrl={this.props.match.url}
          />
        </div>
        <div className="document-abstract-body mb-6 px-2">
          <Route
            path="/files/:rootFolderId/:subId/bulk-upload/:fileId/:tab"
            render={(props) => (
              <RenderedAbstract
                dropdownValueChangeHandler={
                  this.props.dropdownValueChangeHandler
                }
                fieldValueChangeHandler={this.props.fieldValueChangeHandler}
                radioValueChangeHandler={this.props.radioValueChangeHandler}
                checkboxValueChangeHandler={
                  this.props.checkboxValueChangeHandler
                }
                parsedAbstract={this.props.parsedAbstract}
                setInputValue={this.props.setInputValue}
                inputValues={this.props.inputValues}
                {...props}
              />
            )}
          />
        </div>
      </div>
    );
  }
}

export default DocumentAbstract;
